var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-wrapper"},_vm._l((_vm.stepperItems),function(item,index){return _c('div',{key:index,class:['stepper-item', item.classNames,]},[_c('div',{staticClass:"step-counter",on:{"click":function($event){return _vm.logge(item.step)}}},[_c('i',{class:item.icon})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }